<div class="data-filter">
    <label><i *ngIf="icon" class="fa" [ngClass]="icon"></i>&nbsp;<span [i18n]="labelKey"></span></label>
</div>
